<template>
  <div class="table-cols" :class="`table-cols_${layout}`">
    <div class="table-cols__side">
      <div class="table-cols__headers">
        <div class="table-cols__headers-item" v-for="n in colsNumber" :key="`header-item-${n}`">
          <HeaderBox queue-table-hook>
            <HeaderBoxItem>
              {{ getTicketTitle }}
            </HeaderBoxItem>
            <HeaderBoxItem right>
              {{ getExecutorTitle }}
            </HeaderBoxItem>
          </HeaderBox>
        </div>
      </div>
    </div>
    <div class="table-cols__main">
      <div class="table-cols__grids">
        <div v-for="(ticket, index) in tickets" class="table-cols__grid" :key="`table-cols__grid-${index}`">
          <Ticket
            :class="`ticket_${layout}`"
            queue-ticket-hook
            :queue-ticket-label-hook="ticket.seatLabel"
            :queue-ticket-number-hook="ticket.ticketNumber"
            :queue-ticket-title-hook="ticket.title"
            :item="ticket"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Ticket from '@/components/tickets/Ticket'
  import HeaderBox from '@/components/headers/HeaderBox'
  import HeaderBoxItem from '@/components/headers/HeaderBoxItem'
  import { layouts } from '@/app/const/settings'

  export default {
    name: 'TableCols',
    components: {
      Ticket,
      HeaderBox,
      HeaderBoxItem
    },
    props: {
      tickets: {
        type: Array
      },
      layout: {
        type: String
      }
    },
    computed: {
      colsNumber () {
        return this.layout === layouts.col3 ? 3 : 2
      },
      getTicketTitle () {
          return this.$store.state.gui.settings.colorScheme.ticketTitle
              ? this.$store.state.gui.settings.colorScheme.ticketTitle
              : this.$t('common.talon')
      },
      getExecutorTitle () {
        return this.$store.state.gui.settings.colorScheme.executorTitle
            ? this.$store.state.gui.settings.colorScheme.executorTitle
            : this.$t('common.windowNumber')
      }
    }
  }
</script>
